import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { totalBetsSliceActions } from '../../../modules/totalBet/slice';

import { CMDScTotalBetThaihilo, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { ThaiHiLoTotalBet } from '@/models/games/thaiHiLo';

export class CMDScTotalBetThaiHiLoHandler extends AbstractHandler {
    _command: CMDScTotalBetThaihilo;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScTotalBetThaihilo;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const TotalBet = {} as ThaiHiLoTotalBet;
        const HostId = this._command.Total.HostID;
        let totalPlayerCount = 0;
        TotalBet.Hi = this.convertBetAmount(this._command.Hi);
        TotalBet.Lo = this.convertBetAmount(this._command.Lo);
        TotalBet.HiLo11 = this.convertBetAmount(this._command.ElevenHiLo);        
        for (const ba of Object.values(TotalBet)) {
            totalPlayerCount += ba.BetPlayerCount;
        }
        TotalBet.Total = {
            Amount: this._command.Total.Amount,
            BetPlayerCount: totalPlayerCount,
        };
        dispatch(totalBetsSliceActions.update({ HostId, TotalBet }));
    }
}
